import React from "react";
import { Link as LinkReach, useLocation as useLocationReach, navigate as navigateReach } from "@reach/router";

export function Link({ isNext, ...props }) {
  const { to, children } = props;

  if (process.env.IS_NEXT || isNext) {
    return (
      <a {...props} href={to}>
        {children}
      </a>
    );
  } else {
    return <LinkReach {...props} />;
  }
}

export function navigate(to) {
  if (process.env.IS_NEXT) {
    window.location = to;
  } else {
    navigateReach(to);
  }
}

export const useLocation = useLocationReach;
